import axios from "axios";
import * as url from "./url_helper";
import tokenPrefix from "./jwt-token-access/token-prefix";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { formatValue } from "react-currency-input-field";
import { format, parse } from "date-fns";

// Register Method
const base_url = window.location.origin;
const axiosApi = axios.create({
  baseURL: (process.env.REACT_APP_ENABLE_LOCAL_API == 1) ? process.env.REACT_APP_API_URL : base_url
});
axiosApi.interceptors.request.use((config) => {
  let common_request_data = {
    app_version: process.env.REACT_APP_VERISON,
    tenant_sub_domain: localStorage.getItem('user_tenant_sub_domain'),
    device_type: localStorage.getItem('device_type'),
    actual_device: localStorage.getItem('actual_device')
  };
  console.log('axiosApi.interceptors.request', common_request_data);
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      common_request_data: common_request_data,
    };
  } else {
    if (config.data instanceof Array) {
      config.data = {
        data: config.data,
        common_request_data: common_request_data,
      };
    } else if (config.data == null) {
      config.data = {
        common_request_data: common_request_data,
      };
    } else {
      config.data = {
        ...config.data,
        common_request_data: common_request_data,
      };
    }
  }

  return config;
}, (error) => {
  console.error('axiosApi.interceptors.request', error);
  return Promise.reject(error);
});

// const token = tokenPrefix + localStorage.getItem('user_token');
axiosApi.defaults.headers.common["app_version"] = process.env.REACT_APP_VERISON;

// Axios interceptiors
axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
);

// Currency format
export const currencyFormat = (amount) => {
  if (!amount) return null;
  let newAmount = undefined;
  if (amount != undefined) {
    if (amount == Math.floor(amount)) {
      newAmount = amount;
    } else {
      if (amount != undefined) {
        if (typeof (amount) == 'number') {
          newAmount = parseFloat(amount.toFixed(3));
        } else {
          newAmount = parseFloat(Number(amount).toFixed(3));
        }

      }
    }
  }

  if (newAmount != undefined) {
    let t = formatValue({
      value: newAmount.toString(),
      decimalsLimit: 3,
      decimalSeparator: '.',
      intlConfig: { locale: 'en-US', currency: '' },
    });
    return t;
  }
}

// Alert message
const showMessage = (data, toastType = null) => {
  toastr.options = {
    positionClass: 'toast-top-left',
    timeOut: 3000,
    closeButton: true,
    debug: false,
    progressBar: false,
    preventDuplicates: false,
    newestOnTop: true,
    showEasing: 'linear',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  };
  let message = data;
  if (data?.messages)
    message = data.messages[0];
  let title = '';

  // Toaster Types
  if (!toastType)
    toastType = ((data?.status == 'SUCCESS') ? 'SUCCESS' : 'error');
  if (toastType === "info") {
    title = 'Info';
    toastr.info(message, title);
  }
  else if (toastType === "warning") {
    title = 'Warning';
    toastr.warning(message, title);
  }
  else if (toastType === "supper_error") {
    title = 'Error';
    toastr.error(message, title);
  } else if (toastType === "error") {
    title = 'Error';
  } else if (toastType === "playerRedirectionError") {
    title = 'Error';
    toastr.error(message, title);
  }
  else {
    title = 'Success';
    toastr.success(message, title);
  }
}

// Response type
export const respStatus = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}

// Pagination initialize
export const listDataFormat = {
  data: [],
  total: 0,
  per_page: 15,
  current_page: 1
}

// Default page set
export const defaultPerPage = 15;

// Api call method
const makeAjax = (extension, data, micro_service = url.USER_MS_EXT, header = null) => {
  startLoader();
  if (localStorage.getItem('user_token')) {
    let token = tokenPrefix + localStorage.getItem('user_token');
    axiosApi.defaults.headers.common["Authorization"] = token;
  }
  axiosApi.defaults.headers.common["tenant_sub_domain"] = localStorage.getItem('user_tenant_sub_domain');
  axiosApi.defaults.headers.common["device_type"] = localStorage.getItem('device_type');

  let end_url = url.API_PREFIX + url.APPLICATION_EXT + micro_service + extension;
  if (process.env.REACT_APP_ENABLE_LOCAL_API == 2) {
    end_url = url.APPLICATION_EXT + micro_service + extension;
  }
  if (process.env.REACT_APP_LOCAL_EXCEPTION) {
    let exceptional_ms = process.env.REACT_APP_LOCAL_EXCEPTION.split(",");
    if (exceptional_ms.includes(micro_service)) {
      axiosApi.defaults.baseURL = 'http://127.0.0.1';
      end_url = url.API_PREFIX + url.APPLICATION_EXT + micro_service + extension;
    } else {
      axiosApi.defaults.baseURL = (process.env.REACT_APP_ENABLE_LOCAL_API == 1) ? process.env.REACT_APP_API_URL : base_url;
    }
  }
  let requestConfig = {
    url: end_url,
    method: 'post',
    data: data
  };


  // future use
  const validateApiResponseFormat = (responseData) => {
    const expectedKeys = ['status', 'messages', 'data', 'code'];
    if (
      typeof responseData !== 'object' ||
      responseData === null ||
      !expectedKeys.every(key => key in responseData)
    ) {
      console.error('Unexpected API response format:', responseData);
      return false;
    }
    return true;
  };

  return axiosApi(requestConfig)
    .then(response => {
      // if (!validateApiResponseFormat(response.data)) {
      //   console.log("Invalid API response structure in global helper file check endpoints=>" + end_url, "resp=>" + response.data);
      //   return;
      // }
      if (response?.status !== 200) {
        console.log("Invalid API response" + end_url, "resp=>" + response.data);
        window.dispatchEvent(new CustomEvent("showInvalidApiResponseModal", {
          detail: {
            message: "Invalid API response",
            payload: null,
          }
        }));
        return;
      }
      if (response.status >= 200 || response.status <= 299) {
        if (response.data.status == 'ERROR') {
          if (response.data.code == 'validation.access_denied') {
            localStorage.removeItem("user_token");
            localStorage.removeItem("isLoggedIn")
            if (window.location.pathname != '/access-denied')
              window.location.replace(base_url + '/' + "access-denied");
          }
          else if ((response.data.code == 'validation.invalid_token_error' || response.data.code == 'invalid_token_error') && extension != '/logout') {
            localStorage.removeItem("user_token");
            localStorage.removeItem("isLoggedIn");
            if (extension != '/checkIfPinAlreadySet') {
              window.location.href = base_url;
            }
          } else if (response.data.code == 'validation.server_session_out' && extension != '/logout') {
            localStorage.removeItem("user_token");
            localStorage.removeItem("isLoggedIn")
            if (extension != '/checkIfPinAlreadySet') {
              window.location.href = base_url;
            }
          } else if (response?.data?.code == 'togel_game_block') {
            const detail = {
              message: "Invalid API response",
              payload: { data: response.messages },
            }
            window.dispatchEvent(new CustomEvent("showBlockTogelGameCategoryModal", { detail }));
          }
        }
        stopLoader();
        return response.data;
      }
      stopLoader();
      throw response;
    })
    .catch(err => {
      stopLoader();
      catchAxioExc(err);
    });
};

// Loader
if (custom_loader_count === undefined)
  var custom_loader_count = 0;
const startLoader = (extension) => {
  if (custom_loader_count == 0)
    custom_loader_count++;
  var buttonId = document.getElementsByClassName("loaderButton");
  if (buttonId != null && buttonId.length > 0) {
    for (let i = 0; i < buttonId.length; i++) {
      buttonId[i].style.pointerEvents = "none"
    }
  }
}
const stopLoader = () => {
  if (custom_loader_count != 0)
    custom_loader_count--;
  var buttonId = document.getElementsByClassName("loaderButton");
  if (buttonId != null && buttonId.length > 0) {
    for (let i = 0; i < buttonId.length; i++) {
      buttonId[i].style.pointerEvents = ""
    }
  }
}

// Exception defined
const catchAxioExc = (err) => {
  var message;
  if (err.response && err.response.status) {
    switch (err.response.status) {
      case 404:
        message = "Sorry! the API you are looking for could not be found";
        break;
      case 500:
        message =
          "Sorry! something went wrong, please contact our support team";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      default:
        message = err[1];
        break;
    }
    showMessage(message, 'error');
  }
}

// Date format
const currentDate = () => {
  return new Date().toISOString().slice(0, 10);
}

// Timezoe fomat
const formatToLocalDate = (dateString) => {
  try {
    const localDate = parse(dateString, 'yyyy-MM-dd HH:mm:ss', new Date());
    return format(localDate, 'yyyy-MM-dd');
  } catch (error) {
    console.error("Error formatting date:", error);
    return null;
  }
};

const logoutMe = () => {
  return makeAjax(url.USER_API.logout, [], url.USER_MS_EXT).then((response) => {
    if (response.status != respStatus["SUCCESS"] && response.code != 'invalid_token_error') {
      showMessage(response, 'supper_error');
      return false;
    }
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("user_token");
    localStorage.removeItem("pop_up_after_login");
    localStorage.removeItem("pop_up_after_login");
    let ret = alternativeSiteOperation("is_logout");
    console.log('is_logout', ret);
    if (!ret) {
      ret = alternativeSiteOperation("is_primary");
      console.log('is_primary', ret, window.location.origin);
      if (!ret)
        window.location.replace(window.location.origin);
    }
    return true;
  });
}

const alternativeSiteOperation = (operation) => {
  const sites = JSON.parse(localStorage.getItem('alternative_site'));
  const operationMatchingSite = sites.find(s => s[operation]);
  console.log('operationMatchingSite', operation, operationMatchingSite);
  if (checkIsNonPrimary()) {
    return false;
  }
  if (operationMatchingSite && window.location.host != operationMatchingSite.domain) {
    if (operation == 'is_login') {
      let user_logged_in = localStorage.getItem("user_token");
      localStorage.removeItem("user_token");
      window.redirectTo(operationMatchingSite, `/update-token/desktop/${user_logged_in}`);
    }
    else
      window.redirectTo(operationMatchingSite);
    return true;
  }
  return false;
}

const checkIsNonPrimary = () => {
  const sites = JSON.parse(localStorage.getItem('alternative_site'));
  for (let i = 0; i < sites.length; i++) {
    if (!sites[i].is_login && !sites[i].is_logout && !sites[i].is_redirect && !sites[i].is_primary && window.location.host == sites[i].domain)
      return true;
  }
  return false;
}

// Special route
export const prevetHeaderLoad = ['/access-denied'];


// Date format for input
const dateFormat = (inputDate) => {
  if (!inputDate)
    return ' ';
  switch (true) {
    case /^\d{4}-\d{2}-\d{2}$/.test(inputDate):
      const date = new Date(inputDate);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      return `${day}-${month}-${year}`;
    case /^\d{2}-\d{2}-\d{4} \d{2}:\d{2}:\d{2}$/.test(inputDate):
      return inputDate;
    case /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(inputDate):
      const date2 = new Date(inputDate);
      const day2 = date2.getDate().toString().padStart(2, '0');
      const month2 = (date2.getMonth() + 1).toString().padStart(2, '0');
      const year2 = date2.getFullYear().toString();
      const hours = date2.getHours().toString().padStart(2, '0');
      const minutes = date2.getMinutes().toString().padStart(2, '0');
      const seconds = date2.getSeconds().toString().padStart(2, '0');
      return `${day2}-${month2}-${year2} ${hours}:${minutes}:${seconds}`;
    case /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/.test(inputDate):
      return inputDate.replace(/\//g, '-');
    case /^\d{2}-\d{2}-\d{4}$/.test(inputDate):
      return inputDate;
    default:
      return 'invalid date format';
  }
};

// Script extractor added
const extractScriptAttributes = (scriptString, type) => {
  let srcRegex = /src=["'](.*?)["']/;
  let idRegex = /id=["'](.*?)["']/;

  if (type == 'seo') {
    idRegex = /rel=["'](.*?)["']/;
    srcRegex = /href=["'](.*?)["']/;

  }
  const srcMatch = scriptString ? scriptString.match(srcRegex) : '';
  const idMatch = scriptString ? scriptString.match(idRegex) : '';
  const src = srcMatch ? srcMatch[1] : null;
  const id = idMatch ? idMatch[1] : null;
  if (src == null && id == null) {
    let doc = new DOMParser().parseFromString(scriptString, "text/xml");
    let src = doc.firstChild.textContent;
    return { src, id };
  }
  return { src, id };
};


// This function will return in DD MMM YYYY (eg- 09 Mar 2024)
function formatDate(dateString) {
  const date = new Date(dateString);
  const day = ("0" + date.getDate()).slice(-2);
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear().toString();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');
  return `${day} ${month} ${year} ${hours}:${minutes}:${seconds}`;
}

// Export data
export {
  makeAjax,
  url,
  showMessage,
  currentDate,
  dateFormat,
  extractScriptAttributes,
  formatDate,
  formatToLocalDate,
  logoutMe,
  alternativeSiteOperation
};
